import React from "react";

interface Step {
  step: number;
  label: string;
}

interface Props {
  steps: Step[];
  currentStep: number;
  className?: string;
}

const StepIndicator: React.FC<Props> = ({ steps, currentStep, className }) => {
  return (
    <div className={className}>
      <div className="flex justify-between items-center">
        {steps.map(({ step, label }, index) => (
          <React.Fragment key={step}>
            <div className="flex flex-col items-center">
              <div
                className={`rounded-full h-10 w-10 flex items-center justify-center mb-2
                  ${
                    step === currentStep
                      ? `primary-bg-color text-white`
                      : step < currentStep
                      ? "primary-bg-color text-white"
                      : "bg-gray-200 text-gray-600"
                  }`}
              >
                {step < currentStep ? "✓" : index + 1}
              </div>
              <span
                className={`text-sm font-medium whitespace-nowrap
                ${
                  step === currentStep
                    ? `primary-color`
                    : step < currentStep
                    ? "primary-color"
                    : "text-gray-500"
                }`}
              >
                {label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className="flex-1 mx-4">
                <div
                  className={`h-0.5 mt-5
                  ${step < currentStep ? "primary-bg-color" : "bg-gray-200"}`}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
